export const categories = [
  {
    id: 'emotional-guidance',
    name: '情感指导',
    slug: 'emotional-guidance',
    description: '专业情感咨询师为你提供一对一指导，帮你理清情感困惑，找到爱的方向。',
    icon: 'ri-heart-pulse-line',
    count: 24,
  },
  {
    id: 'partner-matching',
    name: '伴侣匹配',
    slug: 'partner-matching',
    description: '基于科学匹配算法，帮你找到灵魂契合的伴侣，让相遇不再靠运气。',
    icon: 'ri-user-heart-line',
    count: 18,
  },
  {
    id: 'relationship-repair',
    name: '感情修复',
    slug: 'relationship-repair',
    description: '感情出现裂痕？专业修复方案帮你重新点燃爱的火花，挽回珍贵关系。',
    icon: 'ri-heart-add-line',
    count: 16,
  },
  {
    id: 'long-term-companion',
    name: '长久陪伴',
    slug: 'long-term-companion',
    description: '学会经营长期关系，让爱在时间中愈加醇厚，守护每一份值得珍惜的感情。',
    icon: 'ri-hand-heart-line',
    count: 20,
  },
  {
    id: 'true-love-stories',
    name: '真爱故事',
    slug: 'true-love-stories',
    description: '真实动人的爱情故事，从他人的经历中汲取爱的力量与智慧。',
    icon: 'ri-book-3-line',
    count: 14,
  },
];